import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withModifiers as _withModifiers, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow } from "vue"
import _imports_0 from '../assets/omi-logo.svg'
import _imports_1 from '../assets/favorite-icon.svg'
import _imports_2 from '../assets/capacity.svg'
import _imports_3 from '../assets/loading.gif'


const _hoisted_1 = { class: "publicsolicitation" }
const _hoisted_2 = { id: "header" }
const _hoisted_3 = { id: "mediums" }
const _hoisted_4 = {
  key: 0,
  "item-selector": ".item",
  resize: true,
  class: "card-box"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "images" }
const _hoisted_7 = ["src", "onLoad"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "child"
}
const _hoisted_11 = {
  key: 1,
  class: "child"
}
const _hoisted_12 = {
  key: 2,
  class: "child"
}
const _hoisted_13 = { class: "p_title" }
const _hoisted_14 = {
  key: 0,
  class: "price"
}
const _hoisted_15 = {
  key: 1,
  class: "price"
}
const _hoisted_16 = { class: "sns" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { style: {"font-weight":"700"} }
const _hoisted_19 = { class: "capacity" }
const _hoisted_20 = { style: {"font-weight":"700"} }
const _hoisted_21 = { class: "first-loading" }

import { useRouter } from "vue-router";
import { nextTick, onMounted, ref, watch } from "vue";
import Masonry from "masonry-layout";
import { ProjectStore } from "../store/ProjectStore";
import { projects } from "../types/apiResponse";
import { CommonStore } from "../store/CommonStore";
import { MEDIA_ICON, MEDIA_TYPE, rowsPerPage } from "../consts/common";


export default /*@__PURE__*/_defineComponent({
  __name: 'PublicSolicitation',
  setup(__props) {

const commonStore = CommonStore();
const store = ProjectStore();

// eslint-disable-next-line @typescript-eslint/no-require-imports
const mediaIcon = ref(require("../assets/instagram.svg"));

const loading = ref(true);
const initDisplay = ref([true, true, true, true]);
const infiteScroll = ref([false, false, false, false]);
const waitingCount = ref(0);
const clickedSns = ref([commonStore.getMediaId]);
const router = useRouter();
const tabchanged = ref(false);
const isMounted = ref(true);
const updatedId = ref(0);
const updatingFavorite = ref(false);

const displayLimit = ref(new Map());

const scrollComponent = ref<HTMLInputElement>();
const pageNum = ref(store.projectListPageNum[commonStore.getMediaId]);

const hiddenLoading = () => {
  if (!loading.value && waitingCount.value) {
    return "visibility: hidden;";
  } else {
    return "visibility: visible;";
  }
};

const click = async (id: number) => {
  store.setSelectedId(id);
  router.push("/project-detail");
  setScrollHeight(commonStore.getMediaId);
};

const getScrollHeight = (): number => {
  if (initDisplay.value[commonStore.getMediaId]) {
    return 0;
  }
  switch (commonStore.getMediaId) {
    case MEDIA_TYPE.INSTAGRAM:
      return commonStore.getInstagramScrollHeight;
    case MEDIA_TYPE.TIKTOK:
      return commonStore.getTiktokScrollHeight;
    case MEDIA_TYPE.YOUTUBE:
      return commonStore.getYoutubeScrollHeight;
    case MEDIA_TYPE.X:
      return commonStore.getXScrollHeight;
    default:
      return 0;
  }
};

function displayList() {
  resize();
  return store.activeProjectList?.get(commonStore.getMediaId) || [];
}

function setScrollHeight(currentMediaId: number) {
  const container = document.getElementsByClassName(
    "container"
  )[0] as HTMLElement;
  if (!container || !container.scrollTop) return;
  if (initDisplay.value[commonStore.getMediaId]) return;
  switch (currentMediaId) {
    case MEDIA_TYPE.INSTAGRAM:
      commonStore.setInstagramScrollHeight(container.scrollTop);
      break;
    case MEDIA_TYPE.TIKTOK:
      commonStore.setTiktokScrollHeight(container.scrollTop);
      break;
    case MEDIA_TYPE.YOUTUBE:
      commonStore.setYoutubeScrollHeight(container.scrollTop);
      break;
    case MEDIA_TYPE.X:
      commonStore.setXScrollHeight(container.scrollTop);
      break;
  }
}

async function changeSns(sns: number) {
  updatedId.value = 0;
  const container = document.getElementsByClassName(
    "container"
  )[0] as HTMLElement;
  clickedSns.value.push(sns);
  waitingCount.value += 1;
  loading.value = true;
  // 一覧呼び出中はscrollできないようにする
  container.style.overflowY = "hidden";
  commonStore.setMediaId(sns);
  await setDisplay(sns)
    .then(async () => {
      await nextTick(() => {
        if (!displayList()?.length) return;
        if (initDisplay.value[commonStore.getMediaId]) {
          container.scrollTo({
            top: 0,
            behavior: "auto",
          });
          initDisplay.value[sns] = false;
        } else {
          container.scrollTo({
            top: getScrollHeight(),
            behavior: "auto",
          });
        }
      });
      container.style.overflowY = "auto";
    })
    .then(() => {
      mediaIcon.value = setMediaIcon(
        clickedSns.value[clickedSns.value.length - 1]
      );
      isDisplayLimit();
      waitingCount.value -= 1;
      container.style.overflowY = "auto";
    })
    .then(() => {
      loading.value = false;
      tabchanged.value = false;
    });
}

onMounted(async () => {
  document.title = "募集中案件";
  isMounted.value = true;
  waitingCount.value += 1;
  const container = document.getElementsByClassName(
    "container"
  )[0] as HTMLElement;
  container.addEventListener("load", resize);
  await setDisplay(commonStore.getMediaId)
    .then(() => {
      waitingCount.value -= 1;
    })
    .then(() => {
      if (initDisplay.value[commonStore.getMediaId]) {
        container.scrollTo({
          top: 0,
          behavior: "auto",
        });
        initDisplay.value[commonStore.getMediaId] = false;
      } else {
        container.scrollTo({
          top: getScrollHeight(),
          behavior: "auto",
        });
      }
      isMounted.value = false;
      // resize();
    });
});
async function handleScroll() {
  // 無限スクロールAPI呼び出し中に上にスクロールした場合のスクロール場所保持
  if (!displayList()?.length) return;
  if (!loading.value) {
    setScrollHeight(commonStore.getMediaId);
  }
  if (store.allCalled[commonStore.getMediaId]) return;
  // 無限スクロールAPI呼び出し中に上にスクロールした場合のスクロール場所保持
  if (loading.value && infiteScroll.value[commonStore.getMediaId]) {
    setScrollHeight(commonStore.getMediaId);
    return;
  }
  // ↑以外API呼び出し中は処理しない
  if (loading.value || waitingCount.value) return;

  const container = document.getElementsByClassName(
    "container"
  )[0] as HTMLElement;
  if (initDisplay.value[commonStore.getMediaId]) {
    container.style.top = 30 + "px";
    initDisplay.value[commonStore.getMediaId] = false;
  }
  initDisplay.value[commonStore.getMediaId] = false;
  if (!displayList().length) return;

  const element = scrollComponent.value;
  if (!element) return;
  if (!container || !container.scrollHeight) return
  if (
    container.scrollHeight - (container.clientHeight + container.scrollTop) >
    1
  )
    return;
  if (
    displayList().length <
    store.projectListPageNum[commonStore.getMediaId] * rowsPerPage
  )
    return;
  loading.value = true;
  pageNum.value = store.projectListPageNum[commonStore.getMediaId] + 1;
  store.setProjectListPageNum(pageNum.value, commonStore.getMediaId);
  // 無限スクロール確認 start
  infiteScroll.value[commonStore.getMediaId] = true;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const confirmScroll: any = (await store.getApi(commonStore.getMediaId)) || [];
  if (confirmScroll.length) infiteScroll.value[commonStore.getMediaId] = false;
  // 無限スクロール確認 end

  // スクロールした追加分も「あと〇〇日」の表示有無セット
  isDisplayLimit();
  // pageNum.value += 1;
  container.style.overflowY = "auto";

  const currentHeight = getScrollHeight();
  if (!container) return;

  container.scrollTo({
    top: currentHeight,
    behavior: "auto",
  });

  loading.value = false;
  // }
}

async function calcHeight(index: number) {
  // if (initLoading.value) return
  const container = document.getElementsByClassName(
    "container"
  )[0] as HTMLElement;

  // if (!index) {
  if (!container) return;
  resize();
  if (displayList() && index != displayList().length - 1) return;

  if (!displayList().length) return;

  const currentHeight = getScrollHeight();
  if (!container) return;

  container.scrollTo({
    top: currentHeight,
    behavior: "auto",
  });

  const lastItem = document.getElementsByClassName(
    `item-${displayList().length - 1}`
  )[0] as HTMLElement;
  const initLoading = document.getElementsByClassName(
    "loading"
  )[0] as HTMLElement;
  if (!lastItem) return;
  initLoading.style.top =
    lastItem.offsetTop + lastItem.scrollHeight - 50 + "px";
}
function resize() {
  const container = document.getElementsByClassName(
    "container"
  )[0] as HTMLElement;
  if (!container) return;
  new Masonry(container, {
    itemSelector: ".item",
  });
}

watch(waitingCount, () => {
  if (waitingCount.value == 0) {
    commonStore.setMediaId(clickedSns.value[clickedSns.value.length - 1]);
    const elements = document.getElementsByName(
      "tab_item"
    ) as NodeListOf<HTMLInputElement>;
    if (elements[commonStore.getMediaId])
      elements[commonStore.getMediaId].checked = true;
    calcHeight(1);
  }
});

const isDisplayLimit = () => {
  if (!displayList().length) {
    return;
  }
  displayList()?.forEach((v, i) => {
    // 日付に変換する
    const dueDate = new Date(v.entry_ended_at);
    const today = new Date(new Date().toDateString());
    const limit = Math.floor((dueDate.getTime() - today.getTime()) / (24 * 60 * 60 * 1000))
    // 管理画面側で00:00締切で登録されるため表示されるチップは−1日で表示する
    displayLimit.value.set(i, { id: v.id, limit: limit -1 });
  });

  loading.value = false;
};

function setMediaIcon(mediaId: number) {
  return MEDIA_ICON[mediaId];
}

// 初期表示 || タブ切り替え時
const setDisplay = async (mediaId: number) => {
  //
  if (!store.activeProjectList) {
    loading.value = true;
    await store.getApi(mediaId);
    initDisplay.value[mediaId] = true;
    mediaIcon.value = setMediaIcon(mediaId);
    // isDisplayLimit();
  } else {
    if (store.activeProjectList.get(mediaId)?.length) {
      loading.value = true;
      initDisplay.value[mediaId] = false;
      mediaIcon.value = setMediaIcon(mediaId);
      // isDisplayLimit();
    } else {
      await store.getApi(mediaId);
      initDisplay.value[mediaId] = true;
      mediaIcon.value = setMediaIcon(mediaId);
      // isDisplayLimit();
    }
  }
  if (displayList().length) {
    // DOM更新まつ
    await nextTick();
    mediaIcon.value = setMediaIcon(mediaId);
    isDisplayLimit();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    displayList().forEach((v: any, index: number) => {
      calcHeight(index);
    });
  }

  // loading.value = false;
};

// お気に入り追加解除
async function updateFavorite(item: projects) {
  if (updatingFavorite.value) return;
  updatingFavorite.value = true;
  if (item.is_favorited) {
    const result = await store.deleteFavoriteProject(item.id);
    if (result) {
      store.updateActiveProject(item, commonStore._mediaId, false);
    }
  } else {
    const result = await store.addFavoriteProject(item);
    if (result) {
      store.updateActiveProject(item, commonStore._mediaId, true);
      updatedId.value = item.id;
    }
  }
  updatingFavorite.value = false;
}

return (_ctx: any,_cache: any) => {
  const _directive_masonry_tile = _resolveDirective("masonry-tile")!
  const _directive_masonry = _resolveDirective("masonry")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "logo" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "OMI-LOGO"
        })
      ], -1 /* HOISTED */)),
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("input", {
          id: "instagram",
          name: "tab_item",
          type: "radio",
          checked: ""
        }, null, -1 /* HOISTED */)),
        _createElementVNode("label", {
          class: "instagram tab_item",
          for: "instagram",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (changeSns(0)))
        }, "Instagram"),
        _cache[6] || (_cache[6] = _createElementVNode("input", {
          id: "tiktok",
          name: "tab_item",
          type: "radio"
        }, null, -1 /* HOISTED */)),
        _createElementVNode("label", {
          class: "tiktok tab_item",
          for: "tiktok",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (changeSns(1)))
        }, "TikTok"),
        _cache[7] || (_cache[7] = _createElementVNode("input", {
          id: "youtube",
          name: "tab_item",
          type: "radio"
        }, null, -1 /* HOISTED */)),
        _createElementVNode("label", {
          class: "youtube tab_item",
          for: "youtube",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (changeSns(2)))
        }, "YouTube"),
        _cache[8] || (_cache[8] = _createElementVNode("input", {
          id: "x",
          name: "tab_item",
          type: "radio"
        }, null, -1 /* HOISTED */)),
        _createElementVNode("label", {
          class: "x tab_item",
          for: "x",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (changeSns(3)))
        }, "X"),
        _cache[9] || (_cache[9] = _createElementVNode("span", { id: "slider" }, null, -1 /* HOISTED */))
      ])
    ]),
    _createElementVNode("section", {
      class: "container",
      ref_key: "scrollComponent",
      ref: scrollComponent,
      onScroll: _cache[4] || (_cache[4] = ($event: any) => (loading.value ? '' : handleScroll()))
    }, [
      _createCommentVNode(" <div > "),
      (!waitingCount.value)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayList(), (item, index) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["item", ['item-' + index]]),
                key: index
              }, [
                _createElementVNode("div", {
                  onClick: ($event: any) => (click(item.id)),
                  class: "imgholder"
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("img", {
                      src: item.image,
                      class: "product-img",
                      onLoad: ($event: any) => (calcHeight(index)),
                      style: _normalizeStyle(
                  displayLimit.value &&
                  displayLimit.value.get(index) &&
                  displayLimit.value.get(index).limit < 0
                    ? 'filter: brightness(0.7);'
                    : ''
                )
                    }, null, 44 /* STYLE, PROPS, NEED_HYDRATION */, _hoisted_7),
                    _createCommentVNode("お気に入りicon"),
                    _createElementVNode("div", {
                      class: "favorite",
                      onClick: _withModifiers(($event: any) => (updateFavorite(item)), ["stop"])
                    }, [
                      _createElementVNode("img", {
                        src: _imports_1,
                        class: _normalizeClass([
                    updatedId.value == item.id && item.is_favorited
                      ? 'update-favorite-icon'
                      : item.is_favorited
                      ? 'favorite-icon'
                      : '',
                  ])
                      }, null, 2 /* CLASS */)
                    ], 8 /* PROPS */, _hoisted_8),
                    (displayLimit.value.get(index) && displayLimit.value.get(index).limit != null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                    displayLimit.value.get(index).limit >= 0 &&
                    displayLimit.value.get(index).limit <= 5
                      ? 'due'
                      : displayLimit.value.get(index).limit < 0
                      ? 'closed'
                      : '',
                  ])
                          }, [
                            _createCommentVNode(" 募集終了まで5日になったら「あと〇〇日」チップ表示する "),
                            (
                      displayLimit.value.get(index).limit > 0 &&
                      displayLimit.value.get(index).limit <= 5
                    )
                              ? (_openBlock(), _createElementBlock("p", _hoisted_10, " あと" + _toDisplayString(displayLimit.value.get(index).limit) + "日 ", 1 /* TEXT */))
                              : (
                      displayLimit.value.get(index).limit == 0
                    )
                                ? (_openBlock(), _createElementBlock("p", _hoisted_11, " 本日まで "))
                                : (displayLimit.value.get(index).limit < 0)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, " 募集終了 "))
                                  : _createCommentVNode("v-if", true)
                          ], 2 /* CLASS */)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("p", _hoisted_13, _toDisplayString(item.title), 1 /* TEXT */),
                  (!item.is_offer)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, " ￥" + _toDisplayString(item.outsourcing_amount.toLocaleString()), 1 /* TEXT */))
                    : (_openBlock(), _createElementBlock("p", _hoisted_15, "応相談")),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("img", {
                      src: mediaIcon.value,
                      alt: "フォロワー以上"
                    }, null, 8 /* PROPS */, _hoisted_17),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(item.min_follower_count.toLocaleString()), 1 /* TEXT */),
                    _cache[11] || (_cache[11] = _createElementVNode("span", null, "フォロワー以上", -1 /* HOISTED */))
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _cache[12] || (_cache[12] = _createElementVNode("img", {
                      src: _imports_2,
                      alt: "募集人数"
                    }, null, -1 /* HOISTED */)),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(item.recruitment_numbers.toLocaleString()), 1 /* TEXT */),
                    _cache[13] || (_cache[13] = _createElementVNode("span", null, "名様", -1 /* HOISTED */))
                  ])
                ], 8 /* PROPS */, _hoisted_5)
              ], 2 /* CLASS */)), [
                [_directive_masonry_tile]
              ])
            }), 128 /* KEYED_FRAGMENT */))
          ])), [
            [_directive_masonry, 'containerId']
          ])
        : _createCommentVNode("v-if", true),
      _withDirectives(_createElementVNode("div", {
        style: _normalizeStyle(hiddenLoading()),
        class: "loading"
      }, _cache[14] || (_cache[14] = [
        _createElementVNode("img", { src: _imports_3 }, null, -1 /* HOISTED */)
      ]), 4 /* STYLE */), [
        [_vShow, loading.value && !waitingCount.value]
      ])
    ], 544 /* NEED_HYDRATION, NEED_PATCH */),
    _withDirectives(_createElementVNode("div", _hoisted_21, _cache[15] || (_cache[15] = [
      _createElementVNode("img", { src: _imports_3 }, null, -1 /* HOISTED */)
    ]), 512 /* NEED_PATCH */), [
      [_vShow, waitingCount.value]
    ])
  ]))
}
}

})